import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgEscalate = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <g>
      <path
        fill={_.color}
        d="M2.794 16q.317 0 .832-.169a9 9 0 0 0 1.108-.453q.6-.284 1.178-.629.585-.338 1.037-.69a.7.7 0 0 1 .17-.1.4.4 0 0 1 .147-.03q.07.007.141.007.07.007.134.007 1.525 0 2.83-.353a8.7 8.7 0 0 0 2.342-.997 7.4 7.4 0 0 0 1.777-1.512 6.5 6.5 0 0 0 1.122-1.918A6.2 6.2 0 0 0 16 6.976q0-1.45-.62-2.717a6.9 6.9 0 0 0-1.715-2.218A8 8 0 0 0 11.118.545 8.8 8.8 0 0 0 8 0a8.8 8.8 0 0 0-3.118.545A8.1 8.1 0 0 0 2.328 2.04 7 7 0 0 0 .614 4.26 6.15 6.15 0 0 0 0 6.976q0 1.227.437 2.332A6.9 6.9 0 0 0 1.7 11.334a8.2 8.2 0 0 0 1.954 1.573q.078.047.1.13a.2.2 0 0 1-.015.162 8 8 0 0 1-.466.73q-.267.375-.522.69-.246.322-.38.514-.205.291-.1.575.114.292.523.292m5.22-4.996a.53.53 0 0 1-.395-.16.62.62 0 0 1-.155-.438V6.469l.056-1.68-.726.951-.861.944a.51.51 0 0 1-.388.176.5.5 0 0 1-.381-.16.6.6 0 0 1-.148-.415q0-.253.148-.415l2.427-2.624q.204-.23.423-.23t.423.23l2.427 2.625q.148.168.148.414a.6.6 0 0 1-.155.414.5.5 0 0 1-.38.161.48.48 0 0 1-.389-.176l-.853-.944-.734-.96.056 1.69v3.936a.62.62 0 0 1-.155.437.5.5 0 0 1-.388.161"
      />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgEscalate);
export default ForwardRef;
